<template>
  <div class="ArchiveDropdown" v-click-outside="handleClickOutside">
    <input 
      type="text" 
      :class="['pill', { active: active }]" 
      :placeholder="getPlaceholder()"
      :value="value"
      @focus="handleFocus"
      @keyup="handleKeyup"
      ref="input"
    >
    <button 
      :class="['toggle', 'icon-button-arrow', { up: open }]"
      @click="handleToggle"
    >
      Toggle
    </button>
    <virtual-list 
      :size="32" 
      :remain="8"
      v-if="open"
      ref="scroller"
      class="scroller"
    >
      <div v-for="item in filteredOptions" :key="item.id" class="scroller-row">
        <div v-if="item.noresults">No Results</div>
        <router-link 
          v-else
          :to="item.id ? `/archive?${taxonomy}=${item.id}` : '/archive'" 
          v-html="item.title"></router-link>
      </div>
    </virtual-list>
  </div>
</template>

<script>
/**
 * Todo:
 * - [x] On click, close field
 * - [x] Filtering
 * - [x] Placeholder current
 * - [x] Add toggle button instead of bg image
 * - [x] Active item highlight
 * - [ ] Non-blocking clicks
 */
import VirtualList from 'vue-virtual-scroll-list'
import vClickOutside from 'v-click-outside'
import Fuse from 'fuse.js'
import decode from 'decode-html'

export default {
  name: 'ArchiveDropdown',
  components: { VirtualList },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    taxonomy: {
      type: String,
      default: ''
    },
    active: {
      default: false
    }
  },
  data () {
    return {
      open: false,
      value: '',
      fuse: null
    }
  },
  created () {
    this.fuse = new Fuse(this.options, {
      minMatchCharLength: 2,
      threshold: 0.5,
      location: 0,
      distance: 0,
      keys: [ 'title' ]
    })
  },
  computed: {
    filteredOptions () {
      let list = this.value ? this.fuse.search(this.value) : this.fuse.list
      if (!list.length) {
        return [{'noresults':true}]
      } else return list
    }
  },
  watch: {
    '$route' () {
      this.doClose()
    }
  },
  methods: {
    handleClickOutside() {
      this.doClose()
    },
    handleFocus() {
      this.open = true
    },
    handleToggle() {
      this.open = !this.open
      if (this.open) {
        this.$refs.input.focus()
      } else {
        this.value = ''
      }
    },
    handleKeyup(e) {
      if (e.keyCode === 27) {
        this.$refs.input.blur()
        this.doClose()
      } else {
        this.value = this.$refs.input.value
        this.$refs.scroller.forceRender()
        this.$refs.scroller.$el.scrollTop = 0
      }
    },
    getPlaceholder() {
      return decode(this.placeholder)
    },
    doClose () {
      this.open = false
      this.value = ''
    }
  }
}
</script>

<style scoped>
.ArchiveDropdown {
  position: relative;
}

input[type="text"] {
  width: 100%;
  text-align: left;
  cursor: text;
  padding-right: 4.5rem;
}

input[type="text"].active::placeholder { color: white }
input[type="text"].active::-moz-placeholder { color: white }
input[type="text"].active:-moz-placeholder { color: white }

.scroller {
  position: absolute;
  top: 5rem;
  left: 0;
  width: 100%;
  z-index: 4;
  height: 25rem;
  
  background-color: white;
  border: var(--b1d);
  border-radius: var(--br1);
  padding: 0.6rem 2rem 0.8rem 2rem;
}

.scroller:not(.page-mode) {
  -webkit-overflow-scrolling: touch; 
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.scroller:not(.page-mode)::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.scroller-row {
  height: 3rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scroller-row .active {
  color: var(--accent);
}

.toggle {
  position: absolute;
  top: 0.5em;
  right: 0.6em;
  height: 1em;
  width: 1em;
  overflow: hidden;
  text-indent: -9999px;
}
</style>